export function useIframePreview() {
  function reloadPreview() {
    const iframes = [...document.querySelectorAll("iframe")];
    if (iframes.length > 0 && iframes[0]) {
      iframes.forEach(function (item) {
        const url = item.src;
        item.src = url;
      });
    } else {
      setTimeout(reloadPreview, 10);
    }
  }

  return {
    reloadPreview,
  };
}
